exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.error[data-v-409bf5ea],\n.loading[data-v-409bf5ea] {\n  display: inline-block;\n}\n.error i[data-v-409bf5ea],\n.loading i[data-v-409bf5ea] {\n  margin-right: 5px;\n}\n.error[data-v-409bf5ea] {\n  font-weight: bold;\n}\n", ""]);

